/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import React from "react";
import GeneralFilter from "../../Shared/Filter/GeneralFilter";
import { resetDeviceFilters } from "../../../store/filters/Nodes/reducer";
import { useMigrationFilter } from "./Filters/hooks";

export const MigrationFilter = () => {
  const { dispatch, filters, formControlSx, searchTooltip } = useMigrationFilter();

  return (
    <>
      <GeneralFilter
        dispatch={dispatch}
        filters={filters}
        formControlSx={formControlSx}
        resetFilters={resetDeviceFilters}
        searchTooltip={searchTooltip}
      />
    </>
  );
};

export default MigrationFilter;
